import {
    ShowCapsFrontPageDL,
    StartCapsGameDL,
    ShuffleCapsGameDL,
    SelectCapAdminDL,
    SelectCapAficionadoDL,
    ResetCapsGameDL,
    EmergencyKickCapsPlayersDL
} from '../DL/Caps';
import SignalRService from '../WS/SignalRService';

let capsAdminMessageHandler = null;
let capsAdminReconnectedHandler = null;
let capsPlayerMessageHandler = null;
let capsPlayerReconnectedHandler = null;

// ==========================================================================
// 🔌 SIGNALR: ADMIN
// ==========================================================================
export const ConnectWebSocketForCapsAdmin = (onIncomingMessage, onStatusChange = () => {}) => {
    onStatusChange('connecting');

    capsAdminMessageHandler = (envelope) => {
        if (envelope && envelope.type && envelope.type.startsWith('caps.')) {
            onIncomingMessage(envelope);
        }
    };

    capsAdminReconnectedHandler = () => {
        onStatusChange('connected');
    };

    SignalRService.on('message', capsAdminMessageHandler);
    SignalRService.on('reconnected', capsAdminReconnectedHandler);

    SignalRService.connect({ tipo: 'superadmin' })
        .then(() => {
            onStatusChange('connected');
        })
        .catch(() => {
            onStatusChange('error');
        });
};

export const DisconnectWebSocketForCapsAdmin = () => {
    if (capsAdminMessageHandler) {
        SignalRService.off('message', capsAdminMessageHandler);
        capsAdminMessageHandler = null;
    }
    if (capsAdminReconnectedHandler) {
        SignalRService.off('reconnected', capsAdminReconnectedHandler);
        capsAdminReconnectedHandler = null;
    }
    SignalRService.disconnect();
};

// ==========================================================================
// 🔌 SIGNALR: AFICIONADO
// ==========================================================================
export const ConnectCapsWebSocket = async (onIncomingMessage, onStatus = () => {}, onToast = () => {}) => {
    onStatus('connecting');

    capsPlayerMessageHandler = (envelope) => {
        onIncomingMessage(envelope);
    };

    capsPlayerReconnectedHandler = () => {
        onStatus('connected');
    };

    SignalRService.on('message', capsPlayerMessageHandler);
    SignalRService.on('reconnected', capsPlayerReconnectedHandler);

    SignalRService.connect({ tipo: 'caps:aficionado' })
        .then(() => {
            onStatus('connected');
            onToast('Conectado a la dinámica 🧢');
        })
        .catch(() => {
            onStatus('error');
        });
};

export const DisconnectCapsWebSocket = () => {
    if (capsPlayerMessageHandler) {
        SignalRService.off('message', capsPlayerMessageHandler);
        capsPlayerMessageHandler = null;
    }
    if (capsPlayerReconnectedHandler) {
        SignalRService.off('reconnected', capsPlayerReconnectedHandler);
        capsPlayerReconnectedHandler = null;
    }
    SignalRService.disconnect();
};

// ==========================================================================
// 📡 PUENTE REST API (Exponiendo al UI)
// ==========================================================================
export const ShowCapsFrontPageBL = async () => await ShowCapsFrontPageDL();
export const StartCapsGame = async (config) => await StartCapsGameDL(config);
export const ShuffleCapsGame = async () => await ShuffleCapsGameDL();
export const SelectCapAdmin = async (capId) => await SelectCapAdminDL(capId);
export const SelectCapAficionadoBL = async (capId) => await SelectCapAficionadoDL(capId);
export const ResetCapsGame = async () => await ResetCapsGameDL();
export const EmergencyKickCapsPlayers = async () => await EmergencyKickCapsPlayersDL();